module.exports = __webpack_public_path__ + "static/media/dir.7945bf4e.png";